import { render, staticRenderFns } from "./question-options.vue?vue&type=template&id=6dd814f0&scoped=true"
import script from "./question-options.vue?vue&type=script&lang=js"
export * from "./question-options.vue?vue&type=script&lang=js"
import style0 from "./question-options.vue?vue&type=style&index=0&id=6dd814f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd814f0",
  null
  
)

export default component.exports